import * as axios from 'axios';
import { API } from './config';

const getCategories = async () =>
{
    try {
        return await axios
            .get(`${API}categories`)
            .then(function(response)
            {
                return response.data;
            })
            .catch(function(e) {
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const getFilterOptions = async () =>
{
    try {
        return await axios
            .get(`${API}filteroptions`)
            .then(function(response)
            {
                return response.data;
            })
            .catch(function(e) {
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const search = async (params) =>
{
    try {
        return await axios
            .post(`${API}filter`, params)
            .then(function(response)
            {
                return response.data;
            })
            .catch(function(e) {
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const getCompanies = async (id) =>
{
    try {
        return await axios
            .get(`${API}companies/${id}`)
            .then(function(response)
            {
                return response.data;
            })
            .catch(function(e) {
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const getCompany = async (id) =>
{
    try {
        return await axios
            .get(`${API}company/${id}`)
            .then(function(response)
            {
                return response.data;
            })
            .catch(function(e) {
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

export const dataService = {
    getCategories,
    getFilterOptions,
    getCompanies,
    getCompany,
    search
};